import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import Delete from 'material-ui-icons/Delete';
import {withStyles} from 'material-ui/styles';
import Dialog, {DialogActions, DialogContent, DialogTitle} from 'material-ui/Dialog';

const styles = theme => ({
	button: {
		margin: theme.spacing.unit
	},
	rightIcon: {
		marginLeft: theme.spacing.unit
	}
});

const DeleteDialog = props => {
	const {
		handleCancel,
		handleConfirm,
		classes,
		deleteTarget: {name, type} = {},
		...rest
	} = props;

	const message = t => {
		switch (t) {
			case 'collection':
				return 'This operation will remove this collection.';
			case 'file':
				return 'This operation will remove this file.';
			case 'user':
				return 'This operation will remove this user.';
			default:
				return 'This operation will remove this object.';
		}
	};

	return (
		<Dialog
			disableBackdropClick
			disableEscapeKeyDown
			aria-labelledby="delete-confirmation-dialog-title"
			{...rest}
		>
			<DialogTitle id="delete-confirmation-dialog-title">
				Are sure you want delete the &quot;{name}&quot;?
			</DialogTitle>
			<DialogContent>
				<Typography component="p">
					{message(type)}
				</Typography>
				<Typography component="p">
					It cannot be undone.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button className={classes.button} onClick={handleCancel} color="default" raised dense>
					Cancel
				</Button>
				<Button className={classes.button} onClick={handleConfirm} color="accent" raised dense>
					Delete
					<Delete className={classes.rightIcon} />
				</Button>
			</DialogActions>
		</Dialog>
	);
};

DeleteDialog.propTypes = {
	classes: PropTypes.object.isRequired,
	handleCancel: PropTypes.func.isRequired,
	handleConfirm: PropTypes.func.isRequired,
	deleteTarget: PropTypes.object.isRequired
};

export default withStyles(styles)(DeleteDialog);



// WEBPACK FOOTER //
// ./src/client/components/admin/common/delete-dialog/delete-dialog.jsx